import { Box, Card, CardActionArea, CardMedia, Grid } from '@material-ui/core';

import breakDefault from '../../../assets/imgs/break-default.svg';

export default function Supporters({ classes, supporters }) {
  return (
    <Box py={2}>
      <Grid container spacing={1}>
        {supporters.map(({ id, name, logo, url }) => (
          <Grid item xs={12} sm={4} key={id}>
            <CardActionArea onClick={() => window.open(url)}>
              <Card square variant="outlined">
                <CardMedia
                  className={classes.supportersMedia}
                  image={logo?.formats?.thumbnail?.url ?? breakDefault}
                  title={name}
                />
              </Card>
            </CardActionArea>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
